export default __webpack_public_path__ + "static/media/480_store03-jp-web.d9443d4e.png";